import presentation from "../../content/registry/presentation.json";

export type ExecutiveSummaryVariant = Readonly<{
  id: string;
  lead: string;
  highlights: readonly string[];
}>;

/**
 * Canonical, approved alternatives used by the homepage's simulated agent cache.
 * The registry schema enforces exactly 50 entries with one lead and two highlights.
 */
export const executiveSummaryVariants: readonly ExecutiveSummaryVariant[] = presentation.executiveSummaryVariants;
